export default __webpack_public_path__ + "static/media/access-sended.370a333a.svg";